module.exports = __webpack_public_path__ + "img/Weapon_244.b095cdf4.png";